// extracted by mini-css-extract-plugin
module.exports = {"customForm":"customForm__kHfnr","buttonContainer":"buttonContainer__36eUi"};